import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/sa/custom-software/driving.webp";

function whychoose(props) {
  return (
    <div
      className="whychoose why_choosedubai p-100"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5}>
            <h2>
              Driving Business Success Through <span>Agile Methodology</span>
            </h2>
            <p>
              Our custom software development team expertly handles problems,
              promptly attends to client needs, and develops websites that not
              only meet but surpass expectations by prioritizing the Agile
              technique and iterative progress.
            </p>
            <p>
              TekRevol, as one of the best custom software development
              companies, builds custom software development solutions by
              translating the client’s requirements into functional,
              result-driven, and responsive mobile-friendly websites. TekRevol
              helps you increase your growth by:
            </p>
            <ul>
              <li>
                Developing flawless functionality and responsive website designs
              </li>
              <li>Reaching And Acquiring New Customers</li>
              <li>Opening new revenue streams and directing energies</li>
              <li>Improving Customer Engagement Rates</li>
              <li>
                Providing post-launch support to ensure long-term website
                success
              </li>
              <li>
                Optimize your website for SEO to improve online visibility
              </li>
            </ul>
            <p>
              To discuss the specifics and ideas of your project, you can
              schedule a meeting with us. Our experts will suggest
              growth-oriented solutions for your business.
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>Apps Developed</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>Review</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>Industries Served</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
